
import {useCallback} from "react";
import {useAppDispatch, useAppSelector} from "../../store";
import appEnv from "../../appEnv";
import {setWindowTitle} from "./generalSlice";

const useGeneral = () => {
    const state = useAppSelector(state => state.general);
    const dispatch = useAppDispatch();

    const setPageName = useCallback((pageName?: string) => {
        const title = appEnv.siteName ?? 'Admin';
        dispatch(setWindowTitle(pageName ? `${title} | ${pageName}` : title));
    }, [dispatch])

    return {
        ...state,
        setPageName
    }
}

export default useGeneral;